import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class CampanaService {
  constructor(private http: HttpClient) {}

  public get(y, m): Observable<{ days: any[]; campaigns: any[] }> {
    return this.http.get<{ days: any[]; campaigns: any[] }>(
      `${environment.serverUrl}api/campana/get`,
      {
        params: { y, m },
      }
    );
  }

  public getUnits(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.serverUrl}api/campana/getUnits`);
  }
  public add(form: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/campana/add`,
      form,
      options
    );
  }
}
